import { ToastContainer } from 'react-toastify';
import Router from './router/Router'
import 'react-toastify/dist/ReactToastify.css';
import ChatBott from './ChatBotWidgett';

function App() {
    return (
        <>
            {/* Diğer componentler */}
            <Router/>
<ChatBott/>
            <ToastContainer position="top-center" />
        </>
    );
}

export default App
